import { render } from "./AbsenceDeleteModal.vue?vue&type=template&id=975aef40&scoped=true&ts=true"
import script from "./AbsenceDeleteModal.vue?vue&type=script&lang=ts"
export * from "./AbsenceDeleteModal.vue?vue&type=script&lang=ts"

import "./AbsenceDeleteModal.vue?vue&type=style&index=0&id=975aef40&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-975aef40"]])

export default __exports__